/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Safe_QInputs */

const en_wc_faq_safe_q = /** @type {(inputs: Wc_Faq_Safe_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where do the download links go?`)
};

/**
* | output |
* | --- |
* | "Where do the download links go?" |
*
* @param {Wc_Faq_Safe_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_safe_q = /** @type {((inputs?: Wc_Faq_Safe_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Safe_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_safe_q(inputs)
});
export { wc_faq_safe_q as "wc.faq.safe.q" }